console.log('Nexus script improvements loaded');